import PropTypes from 'prop-types'
import { m } from 'framer-motion'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Badge, { badgeClasses } from '@mui/material/Badge'

import { Iconify } from '../../../components/Iconify'
import { varHover } from '../../../components/animate'
import { useSettingsContext } from '../../../components/settings'
import { _themeDefaults } from '../../../utils/dataDefaults'

const SettingsButton = ({ sx }) => {

  const { 
    setShowDrawer,
    themeMode,
    themeLayout,
    themeStretch,
    themeContrast,
    themeDirection,
    themeColorPresets,
  } = useSettingsContext()

  const notDefault =
    themeMode !== _themeDefaults.themeMode ||
    themeLayout !== _themeDefaults.themeLayout ||
    themeStretch !== _themeDefaults.themeStretch ||
    themeContrast !== _themeDefaults.themeContrast ||
    themeDirection !== _themeDefaults.themeDirection ||
    themeColorPresets !== _themeDefaults.themeColorPresets

  return (
    <Badge
      color="error"
      variant="dot"
      invisible={!notDefault}
      sx={{
        [`& .${badgeClasses.badge}`]: {
          top: 8,
          right: 8,
        },
        ...sx,
      }}
    >
      <Box
        component={m.div}
      >
        <IconButton
          component={m.button}
          whileTap="tap"
          whileHover="hover"
          variants={varHover(1.05)}
          aria-label="settings"
          onClick={() => setShowDrawer(true)}
          sx={{
            width: 40,
            height: 40,
          }}
        >
          <Iconify icon="solar:settings-bold-duotone" width={24} />
        </IconButton>
      </Box>
    </Badge>
  )
}
SettingsButton.propTypes = {
  sx: PropTypes.object,
}
export { SettingsButton }
